import { CTA } from '@volkswagen-onehub/components-core';
import { Edit } from '@volkswagen-onehub/icons-core';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';
import { useBrandNavigate } from '../../modules/navigation/UseBrandNavigate';
import { Steps } from '../../modules/wizard/Steps';
import { BookingState } from '../../modules/booking-state/BookingState';
import { getPageByStep } from '../../modules/wizard/GetPageByStep';
import { BrandTitlesVw } from '../../modules/wizard/brand-titles/BrandTitlesVw';
import { useTracking } from "../../tracking";

const StyledTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${(props) => props.theme.size.static250};
`;
const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.static350};
  margin-bottom: ${(props) => props.theme.size.static350};
`;

export interface StepDetailsProps {
  step: Steps;
  bookingState: BookingState;
  children: ReactNode;
  noStepElement?: ReactElement;
  stepDescription: string;
  customTitle?: ReactNode;
}

export function StepDetails({ step, bookingState, noStepElement, children, stepDescription, customTitle }: StepDetailsProps): ReactElement | null {
  const navigate = useBrandNavigate();
  const pageRoute = getPageByStep(step, bookingState);
  const trackingService = useTracking();
  const titleContent = customTitle || BrandTitlesVw[step];
  if (!pageRoute) {
    return (
      <div>
        <StyledTitle>{titleContent}</StyledTitle>
        <StyledContent>{noStepElement}</StyledContent>
      </div>
    );
  }

  const onClick = (): void => {
    trackingService.trackButtonClick({
      contentId: stepDescription,
      linkName: '',
      form:
        {
          FormName: 'Review',
          FormStart: false
        }
    });
    navigate(pageRoute);
  };

  return (
    <div>
      <StyledTitle>
        {titleContent}
        <CTA tag="button" emphasis="tertiary" icon={<Edit />} onClick={onClick} />
      </StyledTitle>
      <StyledContent>{children}</StyledContent>
    </div>
  );
}
